<template>
  <img
    :src="isReady ? imageSource : placeholder"
    :alt="alt"
    :width="width"
    :height="height"
    @error="onError"
    @load="onLoad">
</template>

<script>
import Config         from '../config';
import ErrorReporter  from '@istyle-inc/js-error-reporter/vue-error-reporter';
import assign       from 'lodash/assign';
import lozad from 'lozad';

// Object.assign Polyfill (IE11 Support)
if (typeof Object.assign !== 'function') {
  Object.assign = assign;
}

export default {
  name  : 'ImageViewer',
  mixins: [ErrorReporter],
  props : {
    src: {
      type   : [String, URL],
      default: null,
    },
    alt: {
      type   : String,
      default: null,
    },
    altSrc: {
      type   : [String, URL],
      default: null,
    },
    placeholder: {
      type   : [String, URL],
      default: null,
    },
    width: {
      type   : [Number, String],
      default: null,
    },
    height: {
      type   : [Number, String],
      default: null,
    },
    smallLightParams: {
      type   : Object,
      default: () => {},
    },
    async: {
      type   : Boolean,
      default: false,
    },
    loadOffset: {
      type   : [Number, String],
      default: 100,
    },
  },
  data: function() {
    return {
      isReady : !this.async,
      hasError: false,
    };
  },
  computed: {
    smallLightPathParams: function() {
      return Object.keys(this.smallLightParams || {})
        .filter((key) => !!this.smallLightParams[key])
        .map((key) => `${key}=${this.smallLightParams[key]}`)
        .join(',');
    },
    imageSource: function() {
      return this.applySmallLightParams((this.hasError && this.altSrc) || this.src);
    },
  },
  watch: {
    src: function() {
      this.hasError = false;
    },
  },
  mounted: function() {
    if (!this.async) {
      return;
    }
    const observer = lozad(this.$el, {
      rootMargin: `${this.loadOffset}px`,
      load      : (el) => {
        this.isReady = true;
      },
    });
    observer.observe();
  },
  methods: {
    applySmallLightParams(url) {
      if (!url || !this.smallLightPathParams) {
        return url;
      }

      const urlInstance = this.toUrlInstance(url);

      if (!urlInstance || !this.isApplyingTarget(urlInstance)) {
        return url;
      }
      // スモールライトのパラメータが付与されていた場合は除去
      const effectivePathname = urlInstance.pathname.replace(/small_light.*?\//, '');

      const pathname = `small_light(${this.smallLightPathParams})${effectivePathname}`;
      const base = `https://${Config.SMALL_LIGHT_HOST}`;
      return new URL(pathname, base).toString();
    },
    toUrlInstance(url) {
      if (url instanceof URL) {
        return url;
      }

      try {
        // プロトコルが無いとpathnameで取れる値にホストまでついてくるので
        // ↑urlモジュールの仕様だったが、引数にプロトコル無しurlが渡される可能性がある
        url = url.match(/^\/\//) ? `http:${url}` : url;

        return new URL(url);
      } catch (e) {
        return url;
      }
    },
    isApplyingTarget(url) {
      // スモールライトの対象かチェック
      if (url.hostname != Config.SMALL_LIGHT_HOST
       && url.hostname != Config.CDN_HOST
       && url.hostname != 'cdn-cosme.net') { // cdn-cosme.net参照箇所への暫定対応
        return false;
      }
      return true;
    },
    onError() {
      if (!this.isReady) {
        // placeholderのイベントは無視する
        return;
      }
      if (!this.hasError) {
        this.$emit('load-error');
      }
      this.hasError = true;
    },
    onLoad() {
      if (!this.isReady) {
        // placeholderのイベントは無視する
        return;
      }
      if (!this.hasError) {
        this.$emit('load');
      }
    },
  },
};
</script>
